import { AssistantStatusStage } from "./AssistantStatusStage";
import { STATUS_SCREENS } from "./assistant-screens";
import { WakeOrb } from "@/components/WakeOrb";

/** Shared boot shell — idle orb while models / config load. */
export function BootReady() {
  return (
    <AssistantStatusStage
      screen="boot"
      orb={<WakeOrb {...STATUS_SCREENS.boot.orb} />}
      message="Patient Concierge is getting ready…"
    />
  );
}
